<script lang="ts">
    import {createEventDispatcher} from "svelte";
    import {validateStepTwoData} from "./step-two.model.js";
    import {getFormValues} from "../step-one/step-one.model.js";
    import {StepTwoStore} from "../../stores/stores.js";

    const dispatch = createEventDispatcher();

    let errorMsg = null;
    let selectedStatutLegal = "PersonneMorale";
    const formeLegaleOptions = ["SAS", "SARL", "SASU", "EURL", "EI", "SNC", "Particulier"];
    const todayDate = new Date().toISOString().split('T')[0];

    function formSubmit(event) {
        errorMsg = null;
        const formData = getFormValues(event);

        const error = validateStepTwoData(formData);

        if (error) {
            errorMsg = error;
            return;
        }

        StepTwoStore.set({...formData});

        dispatch("nextStep");

    }
</script>

<div>
    <h3 class="title mb-3">Informations du profil</h3>

    <form on:submit|preventDefault={formSubmit}>

        <div class="row">
            <div class="form-group col-12 col-md-6">
                <label for="statutLegal" class="form-label">Statut légal
                    <span class="required">*</span></label>

                <select class="form-select form-select-sm" bind:value={selectedStatutLegal}
                        id="statutLegal" name="statutLegal">
                    <option value="PersonneMorale">Personne morale</option>
                    <option value="PersonnePhysique">Personne physique</option>

                </select>
            </div>

            <div class="form-group col-12 col-md-6">
                <label for="dateCreationEntreprise" class="form-label">Date de création (ou de reprise d'entreprise)
                    <span class="required">*</span>
                </label>
                <input type="date" class="form-control" id="dateCreationEntreprise" max={todayDate}
                       name="dateCreationEntreprise">
            </div>
        </div>

        <!--   si entreprise  -->
        {#if selectedStatutLegal === "PersonneMorale"}
            <div class="row">
                <div class="form-group col-12 col-md-6">
                    <label for="formeLegale" class="form-label">Forme légale
                        <span class="required">*</span>
                    </label>
                    <select name="formeLegale" id="formeLegale" class="form-select form-select-sm">
                        <option value="{null}" selected disabled>-</option>
                        {#each formeLegaleOptions as option}
                            <option value={option}>
                                {option}
                            </option>
                        {/each}
                    </select>
                </div>
                <div class="form-group col-12 col-md-6">
                    <label for="raisonSociale" class="form-label">Raison sociale
                        <span class="required">*</span>
                    </label>
                    <input type="text" class="form-control" id="raisonSociale" name="raisonSociale">
                </div>
            </div>
        {/if}


        <div class="row">
            <div class="form-group col-12 col-md-6">
                <label for="siret" class="form-label">Numéro SIRET
                    <span class="required">*</span>
                </label>
                <input type="text" class="form-control" id="siret" name="siret">
            </div>

            <div class="form-group col-12 col-md-6">
                <label for="activitePro" class="form-label">Activité(s) professionnelles(s)</label>
                <input type="text" class="form-control" id="activitePro" name="activitePro">
            </div>
        </div>

        <div class="row">
            <div class="form-group col-12 col-md-6">
                <label for="nomRepresentant"
                       class="form-label">Nom{selectedStatutLegal === "PersonneMorale" ? " du représentant légal" : ""}
                    <span class="required">*</span>
                </label>
                <input type="text" class="form-control" id="nomRepresentant" name="nomRepresentant">
            </div>
            <div class="form-group col-12 col-md-6">
                <label for="prenomRepresentant"
                       class="form-label">Prénom{selectedStatutLegal === "PersonneMorale" ? " du représentant légal" : ""}
                    <span class="required">*</span>
                </label>
                <input type="text" class="form-control" id="prenomRepresentant" name="prenomRepresentant">
            </div>
        </div>


        <div class="row">
            <div class="form-group col-12 col-md-6">
                <label for="email" class="form-label">Adresse email

                    <span class="required">*</span></label>
                <input type="email" class="form-control" id="email" name="email">
            </div>
            <div class="form-group col-12 col-md-6">
                <label for="phone" class="form-label">Téléphone
                    <span class="required">*</span></label>
                <input type="text" placeholder="Ex : 0000000000" class="form-control" id="phone" name="phone">
            </div>
        </div>

        <div class="row">
            <div class="form-group col-12 col-md-6">
                <label for="dateEffetDemande" class="form-label">Date d'effet demandée
                    <span class="required">*</span></label>
                <input type="date" class="form-control" id="dateEffetDemande" min={todayDate} name="dateEffetDemande">
            </div>
            <!--      <div class="form-group col-12 col-md-6">-->
            <!--        <label for="dateEnvoiDocuments" class="form-label">Date d'envoi des documents pour signature</label>-->
            <!--        <input type="date" class="form-control" id="dateEnvoiDocuments" name="dateEnvoiDocuments">-->
            <!--      </div>-->
        </div>


        <h3 class="title mt-5 mb-4">Informations de facturation</h3>

        <div class="form-group">
            <label for="address" class="form-label">Adresse
                <span class="required">*</span></label>
            <input class="form-control" id="address" name="address" type="text"/>
        </div>

        <div class="row">

            <div class="form-group col-12 col-md-6">
                <label for="city" class="form-label">Ville
                    <span class="required">*</span></label>
                <input class="form-control" id="city" name="city" type="text"/>
            </div>

            <div class="form-group col-12 col-md-6">
                <label for="postalCode" class="form-label">Code postal
                    <span class="required">*</span></label>
                <input class="form-control" id="postalCode" name="postalCode" type="text"/>
            </div>

        </div>

        <div class="row">
            <div class="form-group col-12 col-md-6">
                <label for="fractionnement" class="form-label">Périodicité de fractionnement</label>
                <select class="form-select form-select-sm"
                        id="fractionnement" name="fractionnement">
                    <option value="4" selected>Annuel</option>
                    <option value="3">Semestriel</option>
                    <option value="1">Mensuel</option>

                </select>

            </div>
            <div class="form-group col-12 col-md-6">
                <label for="bic" class="form-label">BIC
                    <span class="required">*</span></label>
                <input class="form-control" id="bic" name="bic" type="text"/>
            </div>
        </div>


        <div class="form-group">
            <label for="iban" class="form-label">IBAN
                <span class="required">*</span></label>
            <input class="form-control" id="iban" name="iban" type="text"/>
        </div>

        {#if errorMsg}
            <div class="bg-danger-subtle p-2 text-center text-danger mt-4 rounded-1">
                {errorMsg}
            </div>
        {/if}

        <footer class="text-center mt-4">
            <button type="submit" class="btn btn-primary">Continuer</button>
        </footer>
    </form>
</div>

<style>

    .title {
        background-color: #A5C641;
        color: white;
        padding: 4px 20px;
        font-weight: 400;
        font-size: 16px;
        width: max-content;
    }


    .form-group {
        margin: 0.5rem 0;
    }

    .form-label {
        margin-bottom: 6px;
        font-size: 14px;
        color: #626262;
    }


    .required {
        color: red;
        font-size: 16px;
        display: inline-block;
    }
</style>
